var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 6.99375H12.2109L9.46172 4.36406C9.42674 4.33132 9.38073 4.31291 9.33281 4.3125H3.375C2.96016 4.3125 2.625 4.64766 2.625 5.0625V18.9375C2.625 19.3523 2.96016 19.6875 3.375 19.6875H20.625C21.0398 19.6875 21.375 19.3523 21.375 18.9375V7.74375C21.375 7.32891 21.0398 6.99375 20.625 6.99375Z",
    fill: "#3463A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 20C13.0899 20 16 17.0899 16 13.5C16 9.91015 13.0899 7 9.5 7C5.91015 7 3 9.91015 3 13.5C3 17.0899 5.91015 20 9.5 20ZM9.5 20C13.088 20 16 17.088 16 13.5C16 9.912 13.088 7 9.5 7C5.912 7 3 9.912 3 13.5C3 17.088 5.912 20 9.5 20ZM10.15 14.15H12.75V12.85H10.15V10.25H8.85V12.85H6.25V14.15H8.85V16.75H10.15V14.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroup);
export default __webpack_public_path__ + "static/media/add-group.8d1125bf6a080afb6d9d7b141cea8f0c.svg";
export { ForwardRef as ReactComponent };